import { render, staticRenderFns } from "./BlackListGeneral.vue?vue&type=template&id=aae2a38a&"
import script from "./BlackListGeneral.vue?vue&type=script&lang=ts&"
export * from "./BlackListGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./BlackListGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports